var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"embedded-code",domProps:{"innerHTML":_vm._s(_vm.getEmbeddedFormCode)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }